import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import MenuPowerBi from '@assets/json/menuPowerBI.json';
import { IRamos } from '@core/models/ramo.models';
import { environment } from '@env/environment';
import { LocalStorageEnum } from '@modules/consulta/produtos/rnpa-pessoas/enumerators';
import  MenuDashboardAntifraude from '@assets/json/menuDashboardAntifraude.json'
import { Observable } from 'rxjs';
import { ApiClass } from './api-class';
import  MenuDashboardSti from '@assets/json/menuDashboardSti.json'
import  MenuDashboardSia from '@assets/json/menuDashboardSia.json'
import  MenuGrupoAssinaturasSti from '@assets/json/menuGrupoAssinaturasSti.json'
import  MenuComissaoSti from '@assets/json/menuComissaoSti.json'

@Injectable({
    providedIn: 'root'
})
export class DashboardService extends ApiClass {

    private environmentUrl = environment.apiGatewayDns
    private homeMenuUrl = '/crud/home/menus'

    constructor(protected httpClient: HttpClient) {
        super(httpClient)
    }

    get powerBiMenu() {
        return MenuPowerBi
    }

    get dashboardAntifraudeMenu() {
        return MenuDashboardAntifraude
    }

    get dashboardStiMenu() {
        return MenuDashboardSti
    }

    get dashboardSiaMenu() {
        return MenuDashboardSia
    }

    get grupoAssinaturasStiMenu() {
        return MenuGrupoAssinaturasSti
    }

    get comissaoStiMenu() {
        return MenuComissaoSti
    }

    getAllRamos(): Observable<HttpResponse<IRamos[]>> {
        const url = environment.lote + this.homeMenuUrl
        return this.httpClient.get<IRamos[]>(url, {observe: 'response'})

    }    
}